import { i18n } from "../../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import imageService from '../../../services/image.service'
import { ImageElement, replaceImageElementImage, replaceImageOpacity } from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputFile from '../../InputFile'
import InputText from '../../InputText'

interface Props {
  selectedElement: ImageElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

interface State {
  imageName: string
  image: File | null
}

class ImageProperties extends Component<CombinedProps, State> {
  constructor (props: CombinedProps) {
    super(props)
    this.state = {
      imageName: '',
      image: null
    }
    this.handleInputFileChange = this.handleInputFileChange.bind(this)
  }

  handleInputFileChange (
    name: string,
    file: File | null,
    filename: string,
    dataUri?: string
  ) {
    if (name === 'image') {
      const { selectedElement } = this.props
      if (!selectedElement) return
      this.setState({ image: file, imageName: filename })
      if (dataUri) {
        const { id } = selectedElement
        imageService.generateImage(dataUri, (image) => {
          this.props.replaceImageElementImage(id, image)
        })
      }
    }
  }

  handleInputChange = (name: string, value: string) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    const { id } = selectedElement
    if (name === 'opacity') this.props.replaceImageOpacity(id, Number(value))
  }

  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'image') return

    return (
      <Fragment>
        <Heading
          className="mb-1"
          text={i18n("Image")}
          size="small" />
        <InputFile
          name="image"
          filename={this.state.imageName}
          accept="image/*"
          label="Upload image"
          onChange={this.handleInputFileChange} />
        <InputText
          type="number"
          name="opacity"
          value={String(selectedElement.opacity)}
          label={i18n("Transparency")}
          onChange={this.handleInputChange} 
          enforceLimits={true} />    
      </Fragment>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {}
}

const mapDispatchToProps = {
  replaceImageElementImage,
  replaceImageOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(ImageProperties)
